export default class ContactService {
  constructor($http, appConfig) {
    "ngInject";

    this.$http = $http;
    this.appConfig = appConfig;
  }

  getContact(entityId, contactId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/contact/get/${entityId}/${contactId}`);
  }

  editContact(contact) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/contact/edit', contact);
  }

  quickEdit(contact) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/contact/quickedit', contact);
  }

  listContacts(filterParams) {
    let query = '';

    query += `?pageStart=${filterParams.pageCriteria.pageStart}`;
    query += `&itemsToFetch=${filterParams.pageCriteria.itemsToFetch}`;
    query += `&sortExpression=${filterParams.pageCriteria.sortExpression}`;
    query += `&ascending=${filterParams.pageCriteria.ascending}`;
    query += `&entityId=${filterParams.entityId}`;

    if (filterParams.contactType) {
      query += `&contactType=${filterParams.contactType}`;
    }

    if (filterParams.contactName) {
      query += `&contactName=${filterParams.contactName}`;
    }

    if (filterParams.companyName) {
      query += `&companyName=${filterParams.companyName}`;
    }

    if (filterParams.ownerName) {
      query += `&ownerName=${filterParams.ownerName}`;
    }

    return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/contact/list' + query);
  }

  updateContactState(entityId, contactId, state) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/contact/update/${entityId}/${contactId}/${state}`);
  }

  searchContacts(entityId, searchTerm) {
    let query = `?entityId=${entityId}`;

    if (searchTerm) {
      query += `&searchTerm=${searchTerm}`;
    }

    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/contact/search${query}`);
  }

  viewContact(entityId, contactId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/contact/view/${entityId}/${contactId}`);
  }

  addEvent(contactId, contactMethod, handledBy, enquiryId) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/contact/addEvent/${contactId}/${contactMethod}/${handledBy}/${enquiryId}`);
  }

  updateDpa(entityId, dpa) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/contact/updatedpa/${entityId}`, dpa);
  }

  updateAllDpa(entityId, dpa) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/contact/updatealldpa/${entityId}`, dpa);
  }

  addNote(entityId, contactId, noteText) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/contact/addNote/${entityId}/${contactId}`, {text: noteText});
  }

  updateOwner(contactId, ownerId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/contact/updateOwner/${contactId}/${ownerId}`);
  }  

  anonymize(contactId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/contact/anonymize/${contactId}`);
  }   
  
  exportContactsToTelecomProvider(entityId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/contact/exportContactsToTelecomProvider/${entityId}`);
  }     

  getCallLog(contactLifeCycleId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/contact/getcalllog/${contactLifeCycleId}`);
  }       
}



// WEBPACK FOOTER //
// ./client/app/components/contact/contact.service.js